import React, {
  ReactNode,
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from 'react';

export const useBlockBrowserBack = (): void => {
  const blockBrowserBack = useCallback((): void => {
    window.history.go(1);
  }, []);

  useEffect((): (() => void) => {
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', blockBrowserBack);

    return (): void => {
      window.removeEventListener('popstate', blockBrowserBack);
    };
  }, [blockBrowserBack]);
};

interface AccessContextType {
  allowedRoutes: string[];
  allowAccess: (route: string) => void;
}

interface Props {
  children: ReactNode;
}

const AccessContext = createContext<AccessContextType | undefined>(undefined);

export const AccessProvider: React.FC<Props> = ({ children }) => {
  const [allowedRoutes, setAllowedRoutes] = useState<string[]>([]);

  const allowAccess = (route: string): void => {
    setAllowedRoutes(prev => [...prev, route]);
  };

  return (
    <AccessContext.Provider value={{ allowedRoutes, allowAccess }}>
      {children}
    </AccessContext.Provider>
  );
};

export const useAccess = (): AccessContextType => {
  const context = useContext(AccessContext);
  if (context === undefined) {
    throw new Error('useAccess must be used within an AccessProvider');
  }
  return context;
};
